import { useDeviceType } from '@cian/ui-kit';
import { useApplicationContext } from '../utils/applicationContext';
import { EHostType } from '../types/hostType';
import { isWebView } from '../utils/isWebView';

export const useMobileBottomNavigation = () => {
  const {
    config,
    custom: { hostType },
  } = useApplicationContext();

  const deviceType = useDeviceType();
  const isWebview = isWebView(config);

  const isMobileBottomNavigationFromHeaderEnabled =
    config.get<boolean>('header-frontend.mobileBottomNavigation.Enabled') ?? false;

  const isMobileBottomNavigationEnabled = config.get<boolean>('mobileBottomNavigation.Enabled') ?? false;

  const isIframe = hostType === EHostType.Frame;

  return (
    isMobileBottomNavigationEnabled &&
    !isMobileBottomNavigationFromHeaderEnabled &&
    deviceType !== 'desktop' &&
    !isIframe &&
    !isWebview
  );
};
